import styles from './IconBadge.module.scss'

import React from 'react'

import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const IconBadge = ({ icon, brand, intent, tone, size, tooltip, children }) => {
  size ??= 1
  return (
    <div className={styles.iconTextContainer} title={tooltip}>
      <Svg icon={icon} brand={brand} intent={intent} tone={tone} size={size} />
      <Typography size={0.875}>{children}</Typography>
    </div>
  )
}

const GuaranteedBadge = () => (
  <IconBadge
    icon="star"
    tooltip="This shipping method is guaranteed to arrive by the delivery date or your shipping fee will be refunded!"
  >
    Guaranteed
  </IconBadge>
)

const PremiumBadge = () => (
  <IconBadge icon="fast_shipping" tooltip="Premium delivery">
    Premium Delivery
  </IconBadge>
)

export default IconBadge
export { GuaranteedBadge, PremiumBadge }
